// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--toastProvider__stack {
  position: fixed;
  z-index: 2100;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
}

.scl--toastProvider__stack .scl--components-popover-toast {
  pointer-events: auto;
}

.scl--toastProvider__stack--bl { left: 24px; bottom: 24px; }
.scl--toastProvider__stack--br { right: 24px; bottom: 24px; }
.scl--toastProvider__stack--tl { left: 24px; top: 24px; }
.scl--toastProvider__stack--tr { right: 24px; top: 24px; }

.scl--toastProvider__item {
  animation: tp-slide-in 0.3s ease forwards;
}

.scl--toastProvider__item.tp-exit {
  animation: tp-slide-out 0.3s ease forwards;
}

@keyframes tp-slide-in {
  from { opacity: 0; transform: translateX(-24px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes tp-slide-out {
  from { opacity: 1; transform: translateX(0); }
  to { opacity: 0; transform: translateX(-24px); }
}
.scl--components-popover-toast-icon{
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-top: 0px;
  top: 0px;
}
.scl--components-popover-toast-title{
  font-weight: 600;
  line-height: 32px;
}
.scl--components-popover-toast{
  width: 442px;
}
.scl--components-popover-toast-description{
  font-size: 16px;
  line-height:  160%;
  margin-left: 40px;
}
.scl--components-popover-toast-close{
  top: 13px;
  right: 13px;
}`, "",{"version":3,"sources":["webpack://./src/context-controller-mod/context-serv/toast-provider/bottomToast/css/ToastProvider.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iCAAiC,UAAU,EAAE,YAAY,EAAE;AAC3D,iCAAiC,WAAW,EAAE,YAAY,EAAE;AAC5D,iCAAiC,UAAU,EAAE,SAAS,EAAE;AACxD,iCAAiC,WAAW,EAAE,SAAS,EAAE;;AAEzD;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC7C,KAAK,UAAU,EAAE,4BAA4B,EAAE;AACjD;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,WAAW;AACb","sourcesContent":[".scl--toastProvider__stack {\n  position: fixed;\n  z-index: 2100;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  pointer-events: none;\n}\n\n.scl--toastProvider__stack .scl--components-popover-toast {\n  pointer-events: auto;\n}\n\n.scl--toastProvider__stack--bl { left: 24px; bottom: 24px; }\n.scl--toastProvider__stack--br { right: 24px; bottom: 24px; }\n.scl--toastProvider__stack--tl { left: 24px; top: 24px; }\n.scl--toastProvider__stack--tr { right: 24px; top: 24px; }\n\n.scl--toastProvider__item {\n  animation: tp-slide-in 0.3s ease forwards;\n}\n\n.scl--toastProvider__item.tp-exit {\n  animation: tp-slide-out 0.3s ease forwards;\n}\n\n@keyframes tp-slide-in {\n  from { opacity: 0; transform: translateX(-24px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes tp-slide-out {\n  from { opacity: 1; transform: translateX(0); }\n  to { opacity: 0; transform: translateX(-24px); }\n}\n.scl--components-popover-toast-icon{\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  margin-top: 0px;\n  top: 0px;\n}\n.scl--components-popover-toast-title{\n  font-weight: 600;\n  line-height: 32px;\n}\n.scl--components-popover-toast{\n  width: 442px;\n}\n.scl--components-popover-toast-description{\n  font-size: 16px;\n  line-height:  160%;\n  margin-left: 40px;\n}\n.scl--components-popover-toast-close{\n  top: 13px;\n  right: 13px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
